<script lang="ts" setup>
  import { computed } from 'vue';
  import { useHttpClient, useTranslator, useRouter } from '@othercommerce/foundation';

  type department = {
    id: number,
    name: string,
  }

  const props = defineProps({
    departments: { type: Object, required: true },
  });

  const http = useHttpClient();
  const translator = useTranslator();
  const router = useRouter();

  const departments = computed(() => {
    return props.departments.map((department: department) => ({
      label: department.name,
      value: department.id,
    }));
  });

  function onSubmit(data: any) {
    return http.post(router.route('web.contact.store'), data);
  }

  const privacyPolicy = computed(() => {
    return translator.trans('SHOP.CONTACT.MESSAGE.CONTACT_PRIVACY_NOTICE', { url: router.route('web.privacyPolicy.index') });
  });
</script>
<template>
  <FormController :title="$t('SHOP.CONTACT.ARIA.CONTACT_FORM')" @submit="onSubmit">
    <div class="contact-form">
      <p v-if="$slots.title" class="contact-form__title">
        <slot name="title" />
      </p>
      <div class="contact-form__inputs">
        <SfFormSelect v-if="departments.length > 1" :label="$t('SHOP.CONTACT.LABEL.DEPARTMENT')" :options="departments" name="contact_department_id" required />
        <SfFormInput :label="$t('SHOP.CONTACT.LABEL.FIRSTNAME')" name="first_name" required type="text" />
        <SfFormInput :label="$t('SHOP.CONTACT.LABEL.LASTNAME')" name="last_name" required type="text" />
        <SfFormInput :label="$t('SHOP.CONTACT.LABEL.PHONE')" name="phone" required type="tel" />
        <SfFormInput :label="$t('SHOP.CONTACT.LABEL.EMAIL')" name="email" required type="email" />
        <SfFormTextarea :label="$t('SHOP.CONTACT.LABEL.MESSAGE')" name="content" required />
        <div class="contact-form__switch">
          <SfFormSwitch class="contact-form__switch" name="acceptance_rodo" required>
            <span v-html="privacyPolicy" />
          </SfFormSwitch>
        </div>
      </div>
      <SfButton class="contact-form__submit" primary type="submit">
        {{ $t('SHOP.CONTACT.ACTION.SEND_MESSAGE') }}
      </SfButton>
    </div>
  </FormController>
</template>
<style lang="scss">
  :root {
    --sf-contact-form-border: none;
    --sf-contact-form-border-radius: 0;
    --sf-contact-form-border-padding-x: 0;
    --sf-contact-form-border-padding-y: 0;

    --sf-contact-form-title-size: 1rem;
    --sf-contact-form-title-color: var(--color-default);
    --sf-contact-form-title-weight: normal;

    --sf-contact-form-submit-text-transform: none;
    --sf-contact-form-submit-weight: normal;

    --sf-contact-form-gap: 1.5rem;
    --sf-contact-form-inputs-gap: 1rem;

  }

  .contact-form {
    display: flex;
    flex-direction: column;
    gap: var(--sf-contact-form-gap);
    border: var(--sf-contact-form-border);
    border-radius: var(--sf-contact-form-border-radius);
    padding: var(--sf-contact-form-border-padding-x) var(--sf-contact-form-border-padding-y);

    &__title {
      font-size: var(--sf-contact-form-title-size);
      color: var(--sf-contact-form-title-color);
      font-weight: var(--sf-contact-form-title-weight);
    }

    &__inputs {
      display: flex;
      flex-direction: column;
      gap: var(--sf-contact-form-inputs-gap);
    }

    &__submit {
      text-transform: var(--sf-contact-form-submit-text-transform);
      font-weight: var(--sf-contact-form-submit-weight);
      align-self: flex-end;
    }

    &__switch a {
      text-decoration: underline;
    }
  }
</style>
